<template>
  <div class="page-add">
    <div class="add-title">申报详情</div>
    <div class="detail-item">
      <div class="item-label">申报名称：</div>
      <div class="item-content">
        {{ info.reportYear }} {{ info.reportName }}
      </div>
    </div>
    <div class="detail-item">
      <div class="item-label">申报时间：</div>
      <div class="item-content">
        {{ info.reportStartTime }} ~ {{ info.reportEndTime }}
      </div>
    </div>
    <div class="detail-item">
      <div class="item-label">申报简介：</div>
      <div class="item-content">{{ info.desc }}</div>
    </div>
    <div class="detail-item" v-if="attachment.length > 0">
      <div class="item-label">申报附件：</div>
      <div class="item-content">
        <downItem :source="JSON.parse(info.attachment)[0]" />
      </div>
    </div>
    <div class="text-center">
      <el-button size="small" @click="goBack">返回</el-button>
    </div>
  </div>
</template>

<script>
import { getClassReportReportInfo } from "@/api/studyService";
import downItem from "@/views/declareClassPlan/detail/downItem.vue";

export default {
  components: {
    downItem,
  },
  data() {
    return {
      info: {},
      attachment: [],
    };
  },
  created() {
    const { reportId } = this.$route.query;
    getClassReportReportInfo({ reportId }).then(({ code, data }) => {
      if (code !== 0) return;
      this.info = data;
      let attachment = JSON.parse(data.attachment) || "";
      if (attachment.length > 0) {
        this.attachment = attachment;
      }
    });
  },
  methods: {
    goBack() {
      this.$router.push('/declareClassPlan');
    }
  }
};
</script>

<style lang="scss" scoped>
.detail-item {
  display: flex;
  font-size: 14px;
  line-height: 30px;
}
.item-label {
  width: 80px;
  text-align: right;
}
.item-content {
  width: calc(100% - 80px);
}
</style>